<div class="modal-shell-header">
  <div class="title">{{ title }}</div>

  <ion-button
    class="modal-shell-close"
    fill="clear"
    (click)="dismissed.emit()"
  >
    <ion-icon name="close-outline"></ion-icon>
  </ion-button>
</div>

<ng-content></ng-content>

<!-- Every modal gets a footer with at least Cancel; modals project their own
     primary actions after it. Order actions secondary-first, primary last.
     A destructive action belongs in the start slot, alone on the left, clear
     of the Cancel/primary cluster. -->
<div class="modal-shell-footer">
  <ng-content select="[modalActionsStart]"></ng-content>
  <ion-button class="modal-shell-cancel" (click)="dismissed.emit()">Cancel</ion-button>
  <ng-content select="[modalActions]"></ng-content>
</div>
